import { Article } from '../../types'

export const MOCK_SCIENCE_ARTICLES: Article[] = [
  {
    source: {
      name: 'SciTechDaily',
    },
    title:
      'NASA, DOE Telescope on Far Side of the Moon Will Reveal the Dark Ages of the Universe - SciTechDaily',
    author: null,
    url: 'https://scitechdaily.com/nasa-doe-telescope-on-far-side-of-the-moon-will-reveal-the-dark-ages-of-the-universe/',
    urlToImage: 'https://scitechdaily.com/images/Commercial-Lunar-Lander.jpg',
    publishedAt: '2023-03-14T08:23:11Z',
  },
  {
    source: {
      name: 'Independent',
    },
    title:
      'Scientists discover superconducting material that could bring total revolution in energy and electronics - The Independent',
    author: 'Andrew Griffin',
    url: 'https://www.independent.co.uk/tech/superconducting-material-lutetium-chemical-energy-b2300242.html',
    urlToImage:
      'https://static.independent.co.uk/2023/03/08/17/fea-superconducting-materials-reddmatter-lutetium-hydride.jpg?quality=75&width=1200&auto=webp',
    publishedAt: '2023-03-14T05:48:09Z',
  },
  {
    source: {
      name: 'SciTechDaily',
    },
    title:
      'Sea Monster From Age of Dinosaurs Found on Remote Arctic Island - SciTechDaily',
    author: null,
    url: 'https://scitechdaily.com/?p=260349',
    urlToImage:
      'https://scitechdaily.com/images/Reconstruction-of-Earliest-Ichthyosaur.jpg',
    publishedAt: '2023-03-14T03:15:22Z',
  },
  {
    source: {
      name: 'ScienceAlert',
    },
    title:
      'Scientists Identify Chemical Reaction That May Have Triggered Life on Earth - ScienceAlert',
    author: 'ScienceAlert',
    url: 'https://www.sciencealert.com/scientists-identify-chemical-reaction-that-may-have-triggered-life-on-earth',
    urlToImage: null,
    publishedAt: '2023-03-14T01:48:15Z',
  },
  {
    source: {
      name: 'Space.com',
    },
    title:
      "SpaceX is 'go' for March 14 cargo launch to space station - Space.com",
    author: 'Mike Wall',
    url: 'https://www.space.com/spacex-go-crs-27-launch-international-space-station',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/frLTBfRA6bLWdDGZWPhGkg-1200-80.jpg',
    publishedAt: '2023-03-14T01:19:53Z',
  },
  {
    source: {
      name: 'Business Insider',
    },
    title:
      'Elon Musk hints Starship rocket may explode on first orbital launch - Business Insider',
    author: 'Marianne Guenot, Morgan McFall-Johnsen',
    url: 'https://www.businessinsider.com/elon-musk-estimates-spacex-starship-first-launch-odds-success-explosion-2023-3',
    urlToImage:
      'https://i.insider.com/640b9669d81e7e0018be0c8b?width=1200&format=jpeg',
    publishedAt: '2023-03-13T23:14:00Z',
  },
  {
    source: {
      name: 'Ars Technica',
    },
    title:
      'Bees learn to dance and to solve puzzles from their peers - Ars Technica',
    author: 'Jennifer Ouellette',
    url: 'https://arstechnica.com/science/2023/03/bees-learn-to-dance-and-to-solve-puzzles-from-their-peers/',
    urlToImage:
      'https://cdn.arstechnica.net/wp-content/uploads/2023/03/beepuzzle2-760x380.jpg',
    publishedAt: '2023-03-13T22:45:37Z',
  },
  {
    source: {
      name: 'The Jerusalem Post',
    },
    title:
      'A new, safer paint keeps buildings cooler- study - The Jerusalem Post',
    author: 'By  JERUSALEM POST STAFF',
    url: 'https://www.jpost.com/business-and-innovation/article-734236',
    urlToImage:
      'https://images.jpost.com/image/upload/f_auto,fl_lossy/t_JD_ArticleMainImageFaceDetect/526430',
    publishedAt: '2023-03-13T22:31:00Z',
  },
  {
    source: {
      name: 'SpaceNews',
    },
    title:
      'NASA planning to spend up to $1 billion on space station deorbit module - SpaceNews',
    author: 'Jeff Foust',
    url: 'https://spacenews.com/nasa-planning-to-spend-up-to-1-billion-on-space-station-deorbit-module/',
    urlToImage:
      'https://spacenews.com/wp-content/uploads/2023/03/iss-march2023.jpg',
    publishedAt: '2023-03-13T21:25:03Z',
  },
  {
    source: {
      name: 'Phys.Org',
    },
    title:
      'Unique image obtained by scientists with high-speed camera shows how lightning rods work - Phys.org',
    author: 'José Tadeu Arantes',
    url: 'https://phys.org/news/2023-03-unique-image-scientists-high-speed-camera.html',
    urlToImage:
      'https://scx2.b-cdn.net/gfx/news/2023/unique-image-obtained.jpg',
    publishedAt: '2023-03-13T20:57:51Z',
  },
  {
    source: {
      name: 'Phys.Org',
    },
    title:
      'Switching to hydrogen fuel could prolong the methane problem - Phys.org',
    author: 'Science X',
    url: 'https://phys.org/news/2023-03-hydrogen-fuel-prolong-methane-problem.html',
    urlToImage:
      'https://scx2.b-cdn.net/gfx/news/2023/switching-to-hydrogen.jpg',
    publishedAt: '2023-03-13T20:57:03Z',
  },
  {
    source: {
      name: 'NASA',
    },
    title:
      "Study Finds Ocean Currents May Affect Rotation of Europa's Icy Crust - NASA Jet Propulsion Laboratory",
    author: 'https://www.jpl.nasa.gov/',
    url: 'https://www.jpl.nasa.gov/news/study-finds-ocean-currents-may-affect-rotation-of-europas-icy-crust',
    urlToImage:
      'https://d2pn8kiwq2w21t.cloudfront.net/original_images/jpegPIA25695.jpg',
    publishedAt: '2023-03-13T20:56:02Z',
  },
  {
    source: {
      name: 'Space.com',
    },
    title:
      "Sorry, Spock, but planet Vulcan's real-life doppelgänger doesn't exist - Space.com",
    author: 'Elizabeth Rayne',
    url: 'https://www.space.com/planet-vulcan-still-science-fiction',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/TQQ4MN9onb7cmcgeyxMJDB-1200-80.jpg',
    publishedAt: '2023-03-13T20:53:00Z',
  },
  {
    source: {
      name: 'OilPrice.com',
    },
    title: 'Satellite Waste Is Becoming A Huge Problem - OilPrice.com',
    author: 'Kurt Cobb',
    url: 'https://oilprice.com/The-Environment/Global-Warming/Satellite-Waste-Is-Becoming-A-Huge-Problem.html',
    urlToImage:
      'https://d32r1sh890xpii.cloudfront.net/article/718x300/2023-03-13_a2qcrokf89.jpg',
    publishedAt: '2023-03-13T20:00:00Z',
  },
  {
    source: {
      name: 'Space.com',
    },
    title:
      "Here's the devastating impact a super-Earth would have on our solar system - Space.com",
    author: 'Sharmila Kuthunur',
    url: 'https://www.space.com/super-earth-impact-solar-system-study',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/wmZsDyezU5sn5D7MKSRWwE-1200-80.jpg',
    publishedAt: '2023-03-13T18:34:47Z',
  },
  {
    source: {
      name: 'WTNH.com',
    },
    title:
      'Did you see it? Meteor lights up Connecticut sky, disintegrates in Milford - WTNH.com',
    author: 'Braley Dodson',
    url: 'https://www.wtnh.com/news/connecticut/new-haven/did-you-see-it-meteor-lights-up-connecticut-sky-disintegrates-in-milford/',
    urlToImage:
      'https://www.wtnh.com/wp-content/uploads/sites/100/2023/03/Meteor-map.jpg?w=1280',
    publishedAt: '2023-03-13T18:09:56Z',
  },
  {
    source: {
      name: 'Nature.com',
    },
    title:
      'Peer review perpetuates barriers for historically excluded groups - Nature.com',
    author: null,
    url: 'https://www.nature.com/articles/s41559-023-01999-w',
    urlToImage:
      'https://media.springernature.com/m685/springer-static/image/art%3A10.1038%2Fs41559-023-01999-w/MediaObjects/41559_2023_1999_Fig1_HTML.png',
    publishedAt: '2023-03-13T16:42:36Z',
  },
  {
    source: {
      name: 'Daily Mail',
    },
    title:
      'Chinese scientists use stem cell technology to grow antlers on MICE - Daily Mail',
    author: 'Fiona Jackson',
    url: 'https://www.dailymail.co.uk/sciencetech/article-11854197/Chinese-scientists-use-stem-cell-technology-grow-antlers-MICE.html',
    urlToImage:
      'https://i.dailymail.co.uk/1s/2023/03/13/16/68652753-0-image-a-22_1678723606193.jpg',
    publishedAt: '2023-03-13T16:41:21Z',
  },
  {
    source: {
      name: 'Space.com',
    },
    title:
      'Double trouble! Two pairs of giant black holes spotted on collision course - Space.com',
    author: 'Robert Lea',
    url: 'https://www.space.com/black-holes-two-pairs-collision-courses-chandra',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/PFsLTRqVRR3rK9p3yWSKAV-1200-80.jpg',
    publishedAt: '2023-03-13T16:30:41Z',
  },
  {
    source: {
      name: 'ScienceAlert',
    },
    title:
      "'Time Reflections' Finally Observed by Physicists After Decades of Searching - ScienceAlert",
    author: 'ScienceAlert',
    url: 'https://www.sciencealert.com/time-reflections-finally-observed-by-physicists-after-decades-of-searching',
    urlToImage: null,
    publishedAt: '2023-03-13T16:00:17Z',
  },
  {
    source: {
      name: 'Phys.Org',
    },
    title:
      "'Counterportation': Quantum breakthrough paves way for world-first experimental wormhole - Phys.org",
    author: 'Science X',
    url: 'https://phys.org/news/2023-03-counterportation-quantum-breakthrough-paves-world-first.html',
    urlToImage:
      'https://scx2.b-cdn.net/gfx/news/hires/2023/landmark-quantum-break.jpg',
    publishedAt: '2023-03-13T15:24:39Z',
  },
  {
    source: {
      name: 'Phys.Org',
    },
    title:
      'Study identifies a new synthesis technique to attain monolayer honeycomb SiC - Phys.org',
    author: 'Ingrid Fadelli',
    url: 'https://phys.org/news/2023-03-synthesis-technique-monolayer-honeycomb-sic.html',
    urlToImage:
      'https://scx2.b-cdn.net/gfx/news/hires/2023/study-identifies-a-new-1.jpg',
    publishedAt: '2023-03-13T15:22:49Z',
  },
  {
    source: {
      name: 'The Jerusalem Post',
    },
    title:
      'Asteroid the size of 69 American alligators to pass Earth Tuesday - NASA - The Jerusalem Post',
    author: 'By  AARON REICH',
    url: 'https://www.jpost.com/science/article-734189',
    urlToImage:
      'https://images.jpost.com/image/upload/f_auto,fl_lossy/t_JD_ArticleMainImageFaceDetect/529482',
    publishedAt: '2023-03-13T15:18:00Z',
  },
  {
    source: {
      name: 'NASASpaceflight.com',
    },
    title:
      'JUICE arrives in French Guiana for launch, project manager outlines next steps - NASASpaceFlight.com - NASASpaceflight.com',
    author: 'Haygen Warren',
    url: 'https://www.nasaspaceflight.com/2023/03/juice-csg-arrival/',
    urlToImage:
      'https://www.nasaspaceflight.com/wp-content/uploads/2023/03/Juice_unpacking_at_Europe_s_Spaceport_in_French_Guiana-495x350.jpg',
    publishedAt: '2023-03-13T15:13:49Z',
  },
  {
    source: {
      name: 'Esa.int',
    },
    title: 'ExoMars: Back on track for the Red Planet - European Space Agency',
    author: null,
    url: 'https://www.esa.int/ESA_Multimedia/Videos/2023/03/ExoMars_Back_on_track_for_the_Red_Planet',
    urlToImage:
      'https://www.esa.int/var/esa/storage/images/esa_multimedia/videos/2023/03/exomars_back_on_track_for_the_red_planet/24751196-1-eng-GB/ExoMars_Back_on_track_for_the_Red_Planet_pillars.png',
    publishedAt: '2023-03-13T15:11:15Z',
  },
]
